// extracted by mini-css-extract-plugin
export default {"component":"LanguagePicker_component__DYOCt"};